import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_staff/settings/persons/_list/_account")(
  {
    component: () => <Outlet />,
  },
);
